export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const FETCH_PASSES = 'FETCH_PASSES';
export const FETCH_USER_PASSES = 'FETCH_USER_PASSES';
